import { useAppSnackbarModule } from '@/store/global/appComponents/appSnackbar';
import { AddSnackbarmessage } from '@/store/global/appComponents/appSnackbar/actions';

function showInfo(message: string) {
    addMessage(message, 'info');
}

function showError(message: string, timeout: number = 8000) {
    addMessage(message, 'error', timeout);
}

function showWarning(message: string, timeout: number = 8000) {
    addMessage(message, 'warning', timeout);
}

function showSuccess(message: string, timeout: number = 3000) {
    addMessage(message, 'success', timeout);
}

/**
 * Shows a snackbar with an action button.
 * @param message - The message to display
 * @param type - The type of snackbar (success, error, warning, info)
 * @param actionText - Text for the action button (e.g., "More details")
 * @param onAction - Callback when the action button is clicked
 * @param timeout - How long to show the snackbar (default 20000ms for action snackbars)
 */
function showWithAction(
    message: string,
    type: 'info' | 'success' | 'error' | 'warning',
    actionText: string,
    onAction: () => void,
    timeout: number = 20000
) {
    const store = useAppSnackbarModule();

    store.dispatch(
        new AddSnackbarmessage({
            message: message,
            isShown: true,
            timeout: timeout,
            type: type,
            actionText: actionText,
            onAction: onAction,
        })
    );
}

function addMessage(message: string, type: 'info' | 'success' | 'error' | 'warning', timeout: number = 3000) {
    const store = useAppSnackbarModule();

    store.dispatch(
        new AddSnackbarmessage({
            message: message,
            isShown: true,
            timeout: timeout,
            type: type,
        })
    );
}

const snackbar = {
    showError,
    showWarning,
    showInfo,
    showSuccess,
    showWithAction,
};

export { snackbar };
